/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CommercialFindingCategory {
    Price = 0,
    Promotion = 1,
    Distribution = 2,
    Margin = 3,
    Sales = 4,
    Media = 5,
    Other = 6,
}
